/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DropDown/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DropDown({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Add/Content/Templates/Content/Referral/Value/DropDown",
  isInvalid,
  onChange
  
}) {
let newReferralReferralListValuesValueData = fromData.useDataValue({ viewPath,
context: 'new_referral',
path: 'referral_list_values',
})
let newReferralTextValueValueData = fromData.useDataValue({ viewPath,
context: 'new_referral',
path: 'text_value',
})
let newReferralTextValueIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_referral',
path: 'text_value',
validate: fromValidate.text,
required: true,
})
let newReferralTextValueChangeData = fromData.useDataChange({ viewPath,
context: 'new_referral',
path: 'text_value',
})
  return (<React.Fragment
>
<div
  data-testid="DropDown.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 field="value"
 marginTop={0}
 size="medium"
 data="new_referral.referral_list_values"
 from={newReferralReferralListValuesValueData}
 data="new_referral.text_value"
 validate="/Data/validate.js text"
 required={true}
 invalid={!newReferralTextValueIsValidData}
 value={newReferralTextValueValueData}
 onChange={newReferralTextValueChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Source"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
</div>
{children}
</React.Fragment>)
}